export const getFileName = (fullPath: string): string =>
  fullPath?.replace(/^.*(\\|\/|:)/, "");
